<template>
    <v-app :lang="$i18n.locale">
        <v-overlay :value="loadingCurrent">
            <v-sheet justify-center align-center outlined color="transparent">
                <v-progress-circular indeterminate :size="50">
                </v-progress-circular> </v-sheet
        ></v-overlay>
        <NavbarTransparent v-if="!black" />
        <NavbarTransparentBlack v-if="black" />
        <v-main>
            <slot></slot>
            <div class="position:absolute; z-index:10;" v-if="isError">
                <LoginFooter @updateLoading="updateLoading" />
            </div>
        </v-main>
    </v-app>
</template>
  
<script>
import i18n from '@/i18n';
import LoginFooter from "../LoginFooter.vue";
import NavbarTransparent from "../NavbarTransparent.vue";
import NavbarTransparentBlack from "../NavbarTransparentBlack.vue";

export default {
    name: "App",
    components: { NavbarTransparent, NavbarTransparentBlack, LoginFooter },
    data: () => ({
        loadingCurrent: 0,
    }),
    props: {
        black: Boolean,
        loading: Number,
        isError: Boolean,
    },
    computed: {
    },
    methods:{
        updateLoading(value = 0){
            this.loadingCurrent = this.loading + value
            if(this.loadingCurrent < 0){
                this.loadingCurrent = 0
            }
        },
        changeLocale(locale){
            localStorage.setItem('language', locale)
            i18n.locale = locale
        }
    },
    mounted(){
        if(localStorage.getItem('language') == null || localStorage.getItem('language') == undefined){
            localStorage.setItem('language', 'th')
        }
        this.changeLocale(localStorage.getItem('language'))
    }
};
</script>
  
<style></style>
  